import React from 'react';
import styled from 'styled-components';
import Context from '../Context';
import Header from './Header';
import HomeScreen from './HomeScreen';
import VideoCollection from './VideoCollection';
import { width100 } from '../constants';

const Router = styled.div`
    ${width100}
`;

export default function RouterComponent() {
  const {
    singleChannel,
  } = React.useContext(Context);

  return (
    <Router className="router">
      <Header />
      {singleChannel && <VideoCollection />}
      {!singleChannel && <HomeScreen />}
    </Router>
  );
}
